exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.user-avatar[data-v-95c0a9f0] {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 100%;\n  letter-spacing: 0.105em;\n  text-transform: uppercase;\n}\n", ""]);
